import React from 'react';

const AddReport = () => {
  return (
    <div className='d-block mx-auto mt-5'>
      <h2 className='text-center text-info'>Please Add Report</h2>
    </div>
  );
};

export default AddReport;